/**
 * YovoTrip breakpoint strategy (MUI defaults):
 *
 * | Range        | MUI key | Design target      |
 * |--------------|---------|--------------------|
 * | 0 – 599px    | xs      | Phone + tablet     |
 * | 600 – 899px  | sm      | (same as phone)    |
 * | 900px+       | md+     | Desktop            |
 *
 * Rule: phone and tablet share ONE design for now.
 * Use `responsive(mobileTablet, desktop)` for all new UI.
 */
export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
};

/** First desktop breakpoint key */
export const DESKTOP_BREAKPOINT = 'md';

/** Max width (px) for the shared phone + tablet layout */
export const MOBILE_TABLET_MAX = breakpoints.values.md - 1; // 899

export const mediaQueries = {
  /** Phone only — avoid unless you need phone-specific tweaks */
  mobile: `(max-width: ${breakpoints.values.sm - 1}px)`,
  /** Tablet only — avoid unless you need tablet-specific tweaks */
  tablet: `(min-width: ${breakpoints.values.sm}px) and (max-width: ${MOBILE_TABLET_MAX}px)`,
  /** Phone + tablet — default for mobile layout (0–899px) */
  mobileTablet: `(max-width: ${MOBILE_TABLET_MAX}px)`,
  /** Desktop — 900px and above */
  desktop: `(min-width: ${breakpoints.values.md}px)`,
};

export default breakpoints;
